import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field-section-toggle"
// Simple toggle that shows/hides a content section with chevron and label swap.
export default class extends Controller {
  static targets = ["content", "chevronDown", "chevronUp", "showLabel", "hideLabel"]

  toggle() {
    const open = !this.contentTarget.classList.contains("hidden")

    this.contentTarget.classList.toggle("hidden", open)
    this.chevronDownTarget.classList.toggle("hidden", !open)
    this.chevronUpTarget.classList.toggle("hidden", open)
    this.showLabelTarget.classList.toggle("hidden", !open)
    this.hideLabelTarget.classList.toggle("hidden", open)
  }
}
